import { ENV, getEnv } from './env';

export const settingsFlag = [ENV.DEV, ENV.UAT].includes(getEnv());
